import SelectPersonUrl from '@src/configs/web.config';

const unionPath = '/wecode/service/system/scope-api-transmission'
// 处理与可见范围后端交互的接口
export const addPermission = (mode: string, releaseInfo: BodyInit | null | undefined) => {
  return new Promise((resolve, reject) => {
    let url = ``;
    if (mode === 'excel') {
      url = `${SelectPersonUrl.visiblecopeUrl.addPermissionByExcel}`;
    } else {
      url = `${SelectPersonUrl.visiblecopeUrl.addPermission}`;
    }
    fetch(unionPath, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      //@ts-ignore
      responseType: 'json',
      body: {
        //@ts-ignore
        method: 'POST',
        path: url,
        body: {
          //@ts-ignore
          ...releaseInfo,
        },
      },
    })
      .then((reply) => {
        resolve(reply);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getPermission = (appTag: { objectId: any; namespace: any; action: any; tenantId: any; }) => {
  return new Promise((resolve, reject) => {
    let url =
      `${SelectPersonUrl.visiblecopeUrl.getPermisson}?pageSize=500&pageNum=1`;
    fetch(unionPath, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      //@ts-ignore
      responseType: 'json',
      body: {
        //@ts-ignore
        method: 'POST',
        path: url,
        body: {
          objectId: appTag.objectId,
          namespace: appTag.namespace,
          action: appTag.action,
          tenantId: appTag.tenantId,
        },
      },
    })
      .then((reply) => {
        resolve(reply);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const transderToPermissionData = (appTag: { objectId: any; namespace: any; objectName: any; action: any; tenantId: any;}, mode: string, origData: any[], isReverses: any, ) => {
  let resData = {
    acpInfo: {
      objectId: appTag.objectId,
      namespace: appTag.namespace,
      objectName: appTag.objectName,
      action: appTag.action,
      tenantId: appTag.tenantId,
    },
    isReverses: isReverses,
    permission: [],
  };
  if (mode === 'AllCanSee') {
    resData.permission.push({
      subjectId: 'all-login-user',
      subjectType: 'all-login-user',
      subjectName: 'all-login-user',
      extendAttribute: {
        isLeaf: false,
        parentKey: [{ key: 0, title: '' }],
      },
    });
  } else {
    origData.forEach((element) => {
      resData.permission.push({
        subjectId: element.key,
        subjectType: element.leafType,
        subjectName: element.title,
        extendAttribute: {
          isLeaf: element.isLeaf,
          parentKey: element.parentKey,
        },
      });
    });
  }
  return resData;
};

export const transferExcelDataToPermissionData = (appTag, excelData) => {
  let resData = {
    acpInfo: {
      objectId: appTag.objectId,
      namespace: appTag.namespace,
      objectName: appTag.objectName,
      action: appTag.action,
    },
    permission: [],
  };
  excelData.forEach((element) => {
    resData.permission.push({
      subjectId: element.Account ? `${element.Account}` : '',
      subjectType: element.Type ? `${element.Type}` : '',
      subjectName: element.Name ? `${element.Name}` : '',
      mobileNumber: element.PhoneNum ? `${element.PhoneNum}` : '',
      corpUserId: element.CorpUserId ? `${element.CorpUserId}` : '',
      email: element.Email ? `${element.Email}` : '',
    });
  });
  return resData;
};

const getItemTitle = (tmpTitle, display, id, translateFun) => {
  if (display === false) {
    return `(${translateFun('Invalidate')})${id}`;
  }
  return tmpTitle ? tmpTitle : '';
};

export const transferFromPermissionData = (origData, language, translateFun) => {
  let resData = [];
  if (origData.code == 200) {
    if ((origData.data.list[0] && origData.data.list[0].subjectType === 'all-login-user') || (origData.data.list?.length === 0)) {
      return 'all-login-user';
    } else {
      origData.data.list.forEach((element) => {
        if (element.subjectType && element.display) {
          let tmpTitle =
            language === 'en' && element.subjectNameEn != null ? element.subjectNameEn : element.subjectName;
          resData.push({
            key: element.subjectId,
            title: tmpTitle ? tmpTitle : '',
            leafType: element.subjectType,
            isLeaf: element.extendAttribute ? element.extendAttribute.isLeaf : true,
            parentKey: element.extendAttribute ? element.extendAttribute.parentKey : [],
            iconType: getIconType(element.subjectType),
          });
        }
      });
    }
  }
  return resData;
};

export const downloadPermissionList = (appTag, language) => {
  let url =
    `${SelectPersonUrl.visiblecopeUrl.getPermisson}s/export?objectId=${appTag.objectId}` +
    `&namespace=${appTag.namespace}&action=common-read&${language === 'en' ? 'language=en' : 'language=zh'}`;
  let downloadUrl = document.createElement('a');
  downloadUrl.href = url;
  downloadUrl.click();
};

export const getIconType = (typeKey) => {
  let res = 'AmuStaffOutlined';
  switch (typeKey) {
    case 'dept':
      res = 'AmuFolderOutlined';
      break;
    case 'user':
      res = 'AmuStaffOutlined';
      break;
    case 'role':
      res = 'TeamOutlined';
      break;
    case 'userGroup':
      res = 'AmuGroupOutlined';
      break;
    case 'admin':
      res = 'AmuAdministratorOutlined';
      break;
    default:
      break;
  }
  return res;
};

// 获取设置数据范围的权限
export const getDomainScopes = ()=>{
  return fetch(`/${process.env.REACT_APP_API_CONTEXT}/service/myAppUserRoleService/getDomainScopes`)
}
